import React from 'react';
export function PainPoints() {
  const points = ['Domingo a la noche buscando cómo bajar a Kant o Nietzsche a un lenguaje que tus alumnos no ignoren', 'Clases improvisadas porque los libros de texto son densos, aburridos y desconectados de la realidad del aula', 'Alumnos en modo "zombi" que solo esperan el timbre porque sienten que la filosofía no tiene nada que ver con su vida', 'Evaluaciones que perdieron todo sentido porque todos usan ChatGPT y no hay reflexión real detrás', 'Horas perdidas construyendo presentaciones que al final nadie mira', 'Textos filosóficos que fascinan en la academia pero generan silencio incómodo cuando los llevás al aula'];
  return <section className="py-8 md:py-12 px-4 bg-brand-cardAlt border-y border-black/5" data-id="element-116">
      <div className="max-w-3xl mx-auto" data-id="element-117">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-center mb-8 text-brand-text" data-id="element-118">
          ¿Te suena familiar?
        </h2>

        {/* Story / Empathy */}
        <div className="bg-brand-card border border-black/10 rounded p-6 mb-8 space-y-4 text-base text-brand-text leading-relaxed" data-id="element-119">
          <p className="font-bold" data-id="element-120">
            Si sos profesor de Filosofía o Ética, esto te va a sonar demasiado
            conocido:
          </p>
          <p data-id="element-121">
            Son las 11 de la noche del domingo. Mañana tenés clase a primera
            hora. Y todavía estás con la computadora abierta, buscando cómo
            bajar a Kant o Nietzsche a un lenguaje que tus alumnos no ignoren.
          </p>
          <p className="font-bold" data-id="element-122">
            No es que seas mal docente. Es que nadie te dio el material
            correcto.
          </p>
          <p data-id="element-123">
            Los textos clásicos son brillantes, sí. Pero cuando intentás
            trabajarlos con adolescentes de hoy, la clase se convierte en un
            monólogo tuyo mientras ellos miran el techo o el celular.
          </p>
          <p data-id="element-124">
            Las actividades que encontrás en internet son genéricas,
            desconectadas del contenido filosófico real, o directamente pensadas
            para otro contexto que no es el tuyo.
          </p>
          <p className="italic" data-id="element-125">Y la planificación... ni hablamos.</p>
        </div>

        <p className="text-center text-brand-text font-bold mb-6 text-lg" data-id="element-126">
          ¿Te identificás con alguna de estas situaciones?
        </p>

        <div className="bg-brand-card border border-black/10 rounded p-6 mb-8" data-id="element-127">
          <div className="space-y-4" data-id="element-128">
            {points.map((point, index) => <div key={index} className="flex items-start" data-id="element-129">
                <span className="text-brand-danger mr-3 shrink-0 mt-0.5 text-lg" data-id="element-130">
                  🔴
                </span>
                <p className="text-base text-brand-text leading-relaxed" data-id="element-131">
                  {point}
                </p>
              </div>)}
          </div>
        </div>

        <div className="text-center space-y-4" data-id="element-132">
          <h3 className="text-lg md:text-xl font-bold text-brand-text leading-tight" data-id="element-133">
            ¿Cuántos fines de semana más vas a perder intentando descifrar
            textos para adolescentes que no quieren leer?
          </h3>
          <p className="text-base text-brand-text font-bold" data-id="element-134">
            El problema no es tu dedicación. El problema es tu herramienta.
          </p>
          <p className="text-base text-brand-text leading-relaxed" data-id="element-135">
            Cada semana sin el material correcto es tiempo robado. Tiempo que no
            pasás en el aula conectando con tus estudiantes. Energía gastada en
            planificación que podría ir directo a enseñar.
          </p>
          <p className="text-lg font-bold text-brand-accent pt-2" data-id="element-136">
            Eso termina hoy.
          </p>
        </div>
      </div>
    </section>;
}